import React from 'react';
import PropTypes from 'prop-types';
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/splide.min.css';
import { observer } from 'mobx-react';

import { capitalize } from '../../utils/helpers';
import AnchorStore from '../../store/AnchorStore';
import Anchor from '../../pages/Anchors/Anchor/Anchor';
import { fetchGalleriesAndVideosCountForAllAnchors } from '../../pages/Anchors/services';


@observer
class AnchorsCarousel extends React.PureComponent {
  intervalId = null;

  state = { availableMediaTotals: {} };

  componentDidMount() {
    if (!AnchorStore.anchors?.currentAnchors?.length) {
      AnchorStore.setAnchors();
    }
    if (!AnchorStore.anchorsWithFanzone?.length) {
      AnchorStore.setAnchorsWithFanzone();
    }
    this.fetchAvailableMediaTotals();
  }

  componentWillUnmount() {
    clearInterval(this.intervalId);
  }

  setAvailableMediaTotals = (responseData) => {
    this.setState({ availableMediaTotals: responseData });
  };

  fetchAvailableMediaTotals = async () => {
    const { error, data } = await fetchGalleriesAndVideosCountForAllAnchors();
    if (!error) {
      this.setAvailableMediaTotals(data?.data);
    }
  };

  getMediaTotalForAnchor = (id) => {
    const { availableMediaTotals } = this.state;

    return availableMediaTotals[id];
  };

  renderAnchorCategories = () => {
    const { anchorsToShow } = this.props;

    return anchorsToShow.map((anchorCategory) => {
      const title = anchorCategory.replace('-', ' ');
      const [anchorStatus, anchorsName] = title.split(' ');
      const anchorType = `${anchorStatus}${capitalize(anchorsName)}`;

      return (

        <div key={anchorCategory} id={anchorCategory}>
          <h1 className="h3 anchor-category-title text-capitalize">
            {title}
          </h1>
          <div className="row-r slider-wrapper">
            <Splide
              className="anchors-slider"
              options={{
                type: 'loop',
                width: '100%',
                drag: 'free',
                arrows: true,
                pagination: true,
                autoWidth: true,

              }}
            >
              {this.renderAnchors(anchorType)}
            </Splide>
          </div>
        </div>

      );
    });
  };

  renderAnchors = (anchorType) => {
    const { anchors, anchorsWithFanzone } = AnchorStore;
    const { user, isGuestHomePage, useAnchorsPageImage } = this.props;
    const isWhitelisted = user ? user?.features?.includes('ANCHOR_PORTAL') : false;

    return (
      anchors?.[anchorType]?.map((anchor, index) => (
        <SplideSlide key={`${anchor.id * index}`}>
          <Anchor
            key={anchor.id}
            anchor={anchor}
            fanZones={anchorsWithFanzone}
            isBroadcasting={false}
            isGuestHomePage={isGuestHomePage}
            isWhitelisted={isWhitelisted}
            mediaTotals={this.getMediaTotalForAnchor(anchor.id) || {}}
            isAnchorsPage={useAnchorsPageImage}
            useAnchorPageFormat={useAnchorsPageImage}
          />
        </SplideSlide>
      ))
    );
  };

  render() {
    const { anchors } = AnchorStore;
    if (!anchors) {
      return null;
    }

    return (
      <div className="content soft-white">
        <div className="container">
          {this.renderAnchorCategories()}
        </div>
      </div>
    );
  }
}

export default AnchorsCarousel;

AnchorsCarousel.propTypes = { anchorsToShow: PropTypes.array };

AnchorsCarousel.defaultProps = {
  anchorsToShow: ['current-anchors', 'guest-anchors', 'past-anchors'],
  useAnchorsPageImage: false,
};
